import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useProfileGuard } from "@/hooks/useProfileGuard";
import { observer } from "mobx-react-lite";
/**
 * 전역 프로필 가드 래퍼. _app에서 페이지를 감싼다.
 * MobX AuthStore.user 변화를 구독(observer)해 프로필/혜택 게이팅을 재평가하고,
 * 리다이렉트가 필요하면 콘텐츠 대신 null을 렌더해 보호 대상 페이지 노출을 막는다.
 */ const ProfileGuard = observer((param)=>{
    let { children  } = param;
    const { blocked  } = useProfileGuard();
    if (blocked) return null;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
});
export default ProfileGuard;
